import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { environment } from './environment';

const app: FirebaseApp = initializeApp(environment.firebaseConfig);

export const auth: Auth = getAuth(app);
